import baseAPI from '@/api/base';
import { CreateFaydaAuthUrl, FaydaExchangeCode } from '@/dtos/fayda.dto';
import {
  FAYDA_AUTH_URL,
  FAYDA_EXCHANGE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Fayda {
  static createAuthUrl = async (
    payload: CreateFaydaAuthUrl
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(FAYDA_AUTH_URL, {
      ...payload,
    });
    console.log('response', response);
    return response;
  };

  static exchangeCodeAndFetchUserInfo = async (
    payload: FaydaExchangeCode
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(FAYDA_EXCHANGE_URL, {
      ...payload
    });
    console.log('response', response);
    return response;
  };
}

export default Fayda;

